<script>

import { onMount, onDestroy } from 'svelte';

import { account_service       , account_service_context_key        } from './_services/account.js';
import { loggedIn                                                   } from './_services/accountsession.js';

</script>

<style>
</style>

<h1>Gallery</h1>

<p>via photoswipe </p>

<p><a href="https://photoswipe.com/">https://photoswipe.com/</a></p>
